$(window).on("load", () => {
  $(document).ready(function () {
    AOS.init({
      // offset: 0,
      // delay: 0
    });
  });

  function header_burger() {
    $(".hamburger").on("click", function () {
      $(this).toggleClass("is-active");
      $(".header-nav .nav__primary").toggleClass("active");
      if ($(".header-nav .nav__primary").hasClass("active")) {
        $("main").addClass("nav-is-active");
      } else {
        $("main").removeClass("nav-is-active");
      }
    });

    $("main").on("click", function () {
      $(".hamburger").removeClass("active");
      $("main").removeClass("nav-is-active");
    });
  }

  function gender_switch() {
    let gender_pills = document.querySelectorAll(".pill--gender");
    const tabs = document.querySelectorAll(".pill-categories");
    const pills = document.querySelectorAll(".pill-categories .pill");
    gender_pills.forEach(function (el) {
      el.addEventListener("click", () => {
        add_or_remove_class_in_selector(".pills-list", "active", false);

        tabs.forEach((tab) => {
          tab.classList.remove("active");
          if (
            tab.getAttribute("data-gender") == el.getAttribute("data-gender")
          ) {
            tab.classList.add("active");
          }
        });

        gender_pills.forEach((element) => {
          element.classList.remove("active");
        });
        el.classList.add("active");
      });
    });
    pills.forEach(function (pill) {
      pill.addEventListener("click", () => {
        add_or_remove_class_in_selector(".pills-list", "active", false);

        document
          .querySelector(
            '.pills-list[data-index="' + pill.getAttribute("data-index") + '"]'
          )
          .classList.add("active");
      });
    });
  }

  let medicines_id = [];
  function category_list_pill() {
    document.querySelectorAll(".pills-list__item").forEach((el) => {
      el.addEventListener("click", function () {
        // medicines_id.push();
        
        medicines_id.push(this.getAttribute("data-post"));
        ajax_add_to_cart();
      });
    });
  }
  function ajax_add_to_cart() {
    event.preventDefault();
    // let button = el.querySelector('[type=submit]');
    let canBeLoaded = true;
    let loading = false;

    var data = {
      action: "add_item_to_cart",
      medicines: medicines_id,
      // count: 5,
    };
    if (canBeLoaded && !loading) {
      loading = true;
      $.ajax({
        url: my_ajax_object.ajaxurl,
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          canBeLoaded = false; // you see, the AJAX call is in process, we shouldn't run it again until complete
          // button.classList.add('loading');
        },
        success: function (response) {
          response = JSON.parse(response);

          canBeLoaded = true; // the ajax is completed, now we can run it again

          if ($("main.front-page").length != 0) {
            window.location = response.redirect;
          }
          loading = false;
        },
        complete: function () {
          // button.classList.remove('loading');
        },
      });
    }
  }

  function show_more_agreements() {
    const btnSwitch = document.getElementById("show_more_agreements");
    const more_agrements = document.getElementById("more_agrements");
    if (btnSwitch) {
      btnSwitch.addEventListener("click", function () {
        // event.preventDefault();
        btnSwitch.classList.toggle("active");
        if (!btnSwitch.classList.contains("active")) {
          more_agrements.classList.add("active");
        } else {
          more_agrements.classList.remove("active");
        }
      });
    }
  }

  function check_all_agreements() {
    const all_agreements = document.getElementById("rodo");
    let all_checkbox = document.querySelectorAll(".checkbox_more_info");
    if (all_agreements) {
      all_agreements.addEventListener("click", () => {
        if (all_agreements.checked) {
          all_checkbox.forEach((el) => {
            el.checked = true;
          });
        } else {
          all_checkbox.forEach((el) => {
            el.checked = false;
          });
        }
      });
    }
  }

  /**
   * Add or remove class from selector
   * @param {string} selector
   * @param {string} [classs_name=active]
   * @param {boolean} [bool=true]
   */
  function add_or_remove_class_in_selector(
    selector,
    classs_name = "active",
    bool = true
  ) {
    let elements = document.querySelectorAll(selector);
    elements.forEach((element) => {
      if (bool) {
        element.classList.add(classs_name);
      } else {
        element.classList.remove(classs_name);
      }
    });
  }
  function post_code_regex() {
    const postCodeInput = document.querySelector(
      "input[name=billing_postcode]"
    );
    let allowpress = true;
    if (postCodeInput) {
      postCodeInput.addEventListener("keydown", function (ev) {
        if (allowpress === true) {
          allowpress = false;
          if (/^[\d{0,1}?(\-)?\d{0,2}?]{0,5}$/.test(this.value)) {
            if (this.value.length === 2) {
              this.value = this.value + "-";
            }
            if (
              this.value.length === 3 &&
              this.value[this.value.length - 1] === "-" &&
              ev.keyCode == 8
            ) {
              ev.preventDefault();
              this.value = this.value.slice(0, -2);
            }
          }
        } else {
          ev.preventDefault();
        }
        return;
      });

      postCodeInput.addEventListener("keyup", function (ev) {
        if (this.value[this.value.length - 1] === "-") {
          this.value = this.value.slice(0, -1);
        }
        if (/^[\d{0,1}?(\-)?\d{0,2}?]{0,6}$/.test(this.value)) {
          // ajax_call(this.value, "pna");
        } else {
          this.value = this.value.slice(0, -1);
        }

        allowpress = true;
      });
    }
  }

  // init doc ready functions
  header_burger();
  gender_switch();
  show_more_agreements();
  check_all_agreements();
  category_list_pill();

  if ($("main.form-main").length != 0) {
    post_code_regex();
  }

  // scroll event
  $(document).scroll(function () {
    function header_animation() {
      const header = document.getElementById("header");
      if (header) {
        if (window.scrollY > 150) {
          header.classList.add("header-mini");
        } else {
          header.classList.remove("header-mini");
        }
      }
    }
    //init scroll functions 
    header_animation();
  });
});
